import React, { useState } from 'react';
import { useNavigate } from 'react-router-dom';
import Swal from 'sweetalert2';
import withReactContent from "sweetalert2-react-content";
import '../Login.css';

const MySwal = withReactContent(Swal);

const Login = () => {
    const [name, setName] = useState('');
    const [password, setPassword] = useState('');
    const [error, setError] = useState('');
    const navigate = useNavigate();

    const handleLogin = async (e) => {
        e.preventDefault();

        try {
            const res = await fetch('https://api.fantasyworldtrpg.cz/echo/login.php', {
                method: 'POST',
                headers: { 'Content-Type': 'application/json' },
                body: JSON.stringify({ name, password }),
            });

            const data = await res.json();

            if (res.ok && data.hash) {
                localStorage.setItem('fw_user', data.hash);
                localStorage.setItem('fw_user_lvl', data.lvl);
                window.location.href = '/char';
            } else {
                MySwal.fire({
                    icon: 'warning',
                    title: 'Chyba',
                    text: data.message || 'Přihlášení selhalo'
                });
            }
        } catch (err) {
            setError(`Chyba při spojení se serverem: ${err}`);
        }
    };

    return (
        <div className="login-wrapper d-flex align-items-center justify-content-center">
            <div className="login-card shadow-lg p-4 rounded-4">
                <h2 className="text-center fw-bold mb-4 text-danger">Síť echo</h2>
                <p className="text-center text-muted lead mb-4">Přihlas se ke svému Fantasy World účtu</p>
                <form onSubmit={handleLogin}>
                    <div className="mb-3">
                        <label className="form-label text-dark">Jméno:</label>
                        <input
                            type="text"
                            className="form-control"
                            value={name}
                            onChange={(e) => setName(e.target.value)}
                            required
                        />
                    </div>
                    <div className="mb-3">
                        <label className="form-label text-dark">Heslo:</label>
                        <input
                            type="password"
                            className="form-control"
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            required
                        />
                    </div>
                    {error && <div className="alert alert-danger py-2">{error}</div>}
                    <button type="submit" className="btn btn-danger w-100 fw-semibold">
                        Přihlásit se
                    </button>
                </form>
            </div>
        </div>
    );
};

export default Login;
